import { TimePicker } from "element-ui";
import FormBase from "./FormBase";
export default {
  name: "AceTimePicker",
  //extends: TimePicker,
  mixins: [TimePicker, FormBase],
  data() {
    return {
      isAuth: true,
    };
  },
  computed: {
    pickerDisabled() {
      return this.disabled || (this.elForm || {}).disabled || this.isOperationDisabled() || !this.isAuth;
    },
  },
};
